import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { Routes, Route } from 'react-router';
import { setLocale } from 'yup';
import { useJotpaRekisterointiDispatch } from './store';
import { JotpaOrganisaatio } from './JotpaOrganisaatio';
import { OrganisationSchema, setInitialOrganisation } from '../organisationSlice';
import { KoodistoContext } from '../KoodistoContext';
import { JotpaPaakayttaja } from './JotpaPaakayttaja';
import { JotpaWizardValidator } from './JotpaWizardValidator';
import { useLanguageContext } from '../LanguageContext';
import { UserSchema } from '../userSlice';
import { JotpaYhteenveto } from './JotpaYhteenveto';
import { useGetKoodistoQuery, useGetOrganisationQuery } from '../rekisterointiApi';
import { usePageTitle } from '../documentHead';
setLocale({
    mixed: {
        required: 'validaatio_pakollinen',
        notType: 'validaatio_geneerinen',
    },
    string: {
        matches: 'validaatio_geneerinen',
        email: 'validaatio_email',
    },
});
const koodistoNimiComparator = (language) => (a, b) => (a.nimi[language] ?? 'xxx') > (b.nimi[language] ?? 'xxx') ? 1 : -1;
export function JotpaRekisterointi() {
    const dispatch = useJotpaRekisterointiDispatch();
    const { language, i18n } = useLanguageContext();
    usePageTitle(i18n.translate('title'));
    const { data: organisation, isError: organisationError } = useGetOrganisationQuery();
    const { data: kunnat = [] } = useGetKoodistoQuery('KUNTA');
    const { data: yritysmuodot = [] } = useGetKoodistoQuery('YRITYSMUOTO');
    const { data: organisaatiotyypit = [] } = useGetKoodistoQuery('ORGANISAATIOTYYPPI');
    const { data: posti = [] } = useGetKoodistoQuery('POSTI');
    useEffect(() => {
        if (organisation) {
            dispatch(setInitialOrganisation(organisation));
        }
    }, [dispatch, organisation]);
    useEffect(() => {
        if (organisationError) {
            window.location.href = '/hakija/logout?redirect=/jotpa';
        }
    }, [organisationError]);
    const koodisto = useMemo(() => {
        const sortKoodit = (koodit) => [...koodit].sort(koodistoNimiComparator(language));
        return {
            kunnat: sortKoodit(kunnat),
            yritysmuodot: sortKoodit(yritysmuodot),
            organisaatiotyypit: sortKoodit(organisaatiotyypit),
            posti,
            postinumerot: posti.map((p) => p.arvo),
        };
    }, [kunnat, language, organisaatiotyypit, posti, yritysmuodot]);
    const organisationValidation = {
        slice: 'organisation',
        schema: OrganisationSchema(koodisto.yritysmuodot, koodisto.kunnat, koodisto.postinumerot),
        redirectPath: '/hakija/jotpa/organisaatio',
    };
    const userValidation = {
        slice: 'user',
        schema: UserSchema,
        redirectPath: '/hakija/jotpa/paakayttaja',
    };
    return (_jsx(KoodistoContext.Provider, { value: koodisto, children: _jsxs(Routes, { children: [_jsx(Route, { path: "/organisaatio", element: _jsx(JotpaOrganisaatio, {}) }), _jsx(Route, { path: "/paakayttaja", element: _jsx(JotpaWizardValidator, { validate: [organisationValidation], children: _jsx(JotpaPaakayttaja, {}) }) }), _jsx(Route, { path: "/yhteenveto", element: _jsx(JotpaWizardValidator, { validate: [organisationValidation, userValidation], children: _jsx(JotpaYhteenveto, {}) }) })] }) }));
}
